<template>
    <modal @modal-close="handleClose">

        <div class="modal-wrapper">

            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <p>
                    {{ isEditingInspection ?
                        $t('Are you sure you want to quit inspection?') :
                        $t('Do you want to keep this inspection as a draft?')
                    }}
                </p>
            </div>


            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        type="button"
                        class="modal-actions-secondary"
                        @click.prevent="handleCancel"
                        >
                        {{ isEditingInspection ? $t('Quit inspection') : $t('Delete draft') }}
                    </button>

                    <button
                        v-if="showSaveDraft"
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleSaveDraft"
                        >
                        {{ $t('Keep draft') }}
                    </button>
                </div>
            </div>

        </div>

    </modal>
</template>

<script>
import CloseButton from '@/components/Modals/CloseButton.vue';

export default {
    components: { CloseButton },

    props: {
        showSaveDraft: {
            type: Boolean,
            default: true,
        },
        isEditingInspection: {
            type: Boolean,
            deafult: false,
        },
    },

    computed: {

    },

    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleCancel() {
            this.$emit('cancel');
        },

        handleSaveDraft() {
            this.$emit('saveDraft');
        },
    },


};
</script>
